import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Intro } from './Intro';
import { Video } from './Video';

const Root = styled.div`
  display: flex;
  padding: calc(${globalTheme.spacing.xl} * 2) 0;
  margin: auto;
  max-width: calc(${globalTheme.spacing.lg} * 68);
`;

export const Body: FC = () => (
  <Root>
    <Intro />
    <Video />
  </Root>
);

